import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

interface IFormContext {
  clientId: string;
  scope: string;
  layer: string;
  setClientId: (value: string) => void;
  setScope: (value: string) => void;
  setLayer: (value: string) => void;
}

const FormContext = createContext<IFormContext>({} as IFormContext);

export const FormProvider = ({ children }: { children: ReactNode }) => {
  const [scope, setScope] = useState("");
  const [clientId, setClientId] = useState("");
  const [layer, setLayer] = useState("experience");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setClientId(params.get("client") ?? "");
    setScope(params.get("scope") ?? "");
    setLayer(params.get("layer") ?? "experience");
  }, []);

  return (
    <FormContext.Provider
      value={{
        scope,
        setScope,
        clientId,
        setClientId,
        layer,
        setLayer,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export const useForm = () => useContext(FormContext);
